const WINTER_BANNER = '/assets/banners/winter.jpg';
const CHRISTMAS_BANNER = '/assets/banners/christmas-1.gif';
const NEW_YEAR_BANNER = '/assets/banners/new-year-1.gif';

export function getSeasonalBanner(date = new Date()): string {
    const month = date.getMonth();
    const day = date.getDate();

    const isNewYear = (month === 11 && day >= 27) || (month === 0 && day <= 2);
    if (isNewYear) {
        return NEW_YEAR_BANNER;
    }

    const isChristmas = month === 11 && day >= 10;
    if (isChristmas) {
        return CHRISTMAS_BANNER;
    }

    return WINTER_BANNER;
}
